import React from "react";
import type { IToastMessage } from "services/store/types";
import { useMutationRemoveToastMessage, useQueryToast } from "./hooks";

function Message({ message }: { message: IToastMessage }) {
  const removeToastMessage = useMutationRemoveToastMessage();

  const [visible, setVisible] = React.useState(false);

  const slideUp = () => {
    setVisible(false);
    setTimeout(() => {
      removeToastMessage.mutate(message);
    }, 2000);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dis' how it was
  React.useEffect(() => {
    if (!message || visible) {
      return;
    }
    setVisible(true);
    setTimeout(() => {
      setTimeout(slideUp, message.timeout);
    }, 10);
  }, []);

  return (
    <div
      data-visible={visible}
      data-type={message.type}
      className="fixed inset-x-0 z-10000 flex h-auto w-full items-start justify-center p-3 shadow-back transition-transform duration-300 ease-in-out data-[type=ERROR]:bg-error data-[type=INFO]:bg-info data-[type=SUCCESS]:bg-success data-[type=WARNING]:bg-warning data-[visible=false]:-translate-y-[120%] data-[visible=true]:translate-y-0"
    >
      <p
        data-type={message.type}
        className="text-large font-semibold data-[type=ERROR]:text-white data-[type=INFO]:text-white data-[type=SUCCESS]:text-white data-[type=WARNING]:text-black"
      >
        {message.text}
      </p>
    </div>
  );
}

export function ToastMessage() {
  const { data: messages } = useQueryToast();
  if (!messages?.length) {
    return null;
  }
  return <>{Array.isArray(messages) && messages.map((message) => <Message key={message.id} message={message} />)}</>;
}
